import { Component, OnInit } from '@angular/core';
import { AuthorizeService } from 'src/app/services/authorize/authorize.service';
import { FeatureBellService } from 'src/app/services/feature-bell/feature-bell.service';


@Component({
  selector: 'app-helpPage',
  templateUrl: './help-page.component.html',
  styleUrls: ['./help-page.component.scss']
})
export class HelpPageComponent implements OnInit {
  helpClass: 'light' | 'dark' = 'dark';
  private readonly helpFeatureId = 'help-page-2026';

  pdfLinks = [
    {
      category: 'Alerts',
      name: 'Alerts - How to Manage and Assign Alert Profiles for Tanks',
      url: '/assets/help/Alerts - How to Manage and Assign Alert Profiles for Tanks.pdf'
    },
    {
      category: 'Employees',
      name: 'Employees - Adding an Employee to Your Dashboard Account',
      url: '/assets/help/Employees - Adding an Employee to Your Dashboard Account.pdf'
    },
    {
      category: 'Customers and Tanks',
      name: 'Customers and Tanks - Managing Customer Accounts and Tank Information_V1',
      url: '/assets/help/Customers and Tanks - Managing Customer Accounts and Tank Information_V1.pdf'
    },
    {
      category: 'Customers and Tanks',
      name: 'Tanks - Changing or Deleting a Tank or Unit from the Dashboard',
      url: '/assets/help/Tanks - Changing or Deleting a Tank or Unit from the Dashboard.pdf'
    },
    {
      category: 'Tank Groups',
      name: 'Tank Groups - Create and Manage Tank Groups and Routes',
      url: '/assets/help/Tank Groups - Create and Manage Tank Groups and Routes.pdf'
    },
    {
      category: 'Branches',
      name: 'Branches - Managing Branches and Assigned One-Tank Pulse Units in the One-Tank Dashboard',
      url: '/assets/help/Branches - Managing Branches and Assigned One-Tank Pulse Units in the One-Tank Dashboard.pdf'
    },
    {
      category: 'Billing Management',
      name: 'Billing Management - Managing OneTank Device Activation and Deactivation Status',
      url: '/assets/help/Billing Management - Managing OneTank Device Activation and Deactivation Status.pdf'
    },
    {
      category: 'User Guide',
      name: 'Pulse Tank Monitor User Guide',
      url: '/assets/help/Pulse Tank Monitor User Guide (PLS1006-08).pdf'
    }
  ]


  constructor(
    private _authorizeService: AuthorizeService, private featureBellService: FeatureBellService) {

  }

  ngOnInit() {
    if (localStorage.getItem('theme') == "light") {
            this.helpClass = 'light'
        } else {
            this.helpClass = 'dark'
        }

        this.featureBellService.markSeen(this.helpFeatureId);
  }


  get groupedPdfs() {
    const groups: { [key: string]: any[] } = {};

    for (const pdf of this.pdfLinks) {
      if (!groups[pdf.category]) {
        groups[pdf.category] = [];
      }
      groups[pdf.category].push(pdf);
    }

    return groups;
  }



}
